import appEvents from "../../views/appSettings/events.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "events";
  const params = ["page", "limit"];

  $stateProvider.state("events", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appEvents,
      },
    },
    reloadOnSearch: false,
    data: { title: "Events" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/events/events.urls.js